import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

/**
 * Shell for the dedicated single-table pages.
 *
 * Deliberately thin. The table components already carry their own heading and
 * action bar, so duplicating a title here would just print it twice — `title`
 * is therefore optional and used only for the one table (Production Jobs)
 * whose heading lives in its host page rather than in the component itself.
 *
 * All this really adds is the way back, since these routes are not in the nav.
 */
const FullTableLayout = ({ backTo, backLabel, title, subtitle, children }) => (
  <div className="pb-9">
    <Link
      to={backTo}
      className="btn btn-link ps-0 mb-2 text-decoration-none fs-9"
    >
      <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
      Back to {backLabel}
    </Link>

    {title && (
      <div className="mb-3">
        <h2 className="mb-1">{title}</h2>
        {subtitle && <p className="text-700 mb-0 fs-9">{subtitle}</p>}
      </div>
    )}

    {children}
  </div>
);

export default FullTableLayout;
